import {
  Box,
  Button,
  createStyles,
  Theme,
  Typography,
  withStyles,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import managerCategoryApi from "api/managerCategory";
import {useAppDispatch, useAppSelector} from "app/hooks";
import {useConfirm} from "material-ui-confirm";
import {ResponseStatus} from "models/common";
import {Category} from "models/managerCategory";
import React, {Fragment, useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import {fetchCategoryList, selectCategoryList} from "../../managerCategorySlice";
import EditCategory from "../EditCategory";
import useStyles from "./style";
import EmptyComponent from "components/Empty";

export default function TableCategory() {
  const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
      head: {
        padding: "14px 16px",
        backgroundColor: "#F8FAFC",
        color: "#0F172A",
        fontSize: 12,
        fontWeight: 700,
        borderRight: "1px solid #F1F5F9",
        borderBottom: "2px solid #E2E8F0",
        top: "0 !important",
        [theme.breakpoints?.up("xl")]: {
          fontSize: 14,
        },
      },
      body: {
        padding: "12px 16px",
        fontSize: 12,
        borderRight: "1px solid #F1F5F9",
        borderBottom: "1px solid #F1F5F9",
        fontWeight: 500,
        color: "#334155",
        [theme.breakpoints?.up("xl")]: {
          fontSize: 13,
        },
      },
    })
  )(TableCell);
  const dispatch = useAppDispatch();
  const {t} = useTranslation();
  const [openModal, setOpenModal] = useState(false);
  const categoryList = useAppSelector(selectCategoryList);
  const [valueCategory, setValueCategory] = useState<Category>({
    name: "",
    id: 0,
  });

  const classes = useStyles();
  const confirm = useConfirm();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const targetParents: HTMLElement[] = [];
    const originalOverflows: string[] = [];

    if (containerRef.current) {
      let parent = containerRef.current.parentElement;
      while (parent && parent.tagName !== "MAIN") {
        const computedStyle = window.getComputedStyle(parent);
        if (
          computedStyle.overflow === "hidden" ||
          computedStyle.overflowX === "hidden" ||
          computedStyle.overflowY === "hidden"
        ) {
          targetParents.push(parent);
          originalOverflows.push(parent.style.overflow);
          parent.style.overflow = "visible";
        }
        parent = parent.parentElement;
      }
    }

    return () => {
      targetParents.forEach((parent, index) => {
        if (parent) {
          parent.style.overflow = originalOverflows[index];
        }
      });
    };
  }, [categoryList]);

  const handleDeleteCategory = (category: Category) => {
    confirm({
      title: (
        <Typography variant="h5" color="secondary">
          {t("delete.chuy")}
        </Typography>
      ),
      description: (
        <Typography variant="subtitle2">
          {t("delete.khiban")}{" "}
          <Typography variant="subtitle2" component="span" color="secondary">
            {t("delete.dongy")}
          </Typography>{" "}
          {t("delete.xoa")}
          <Typography variant="subtitle2" component="span" style={{color: "#004673"}}>
            {" "}
            {category.name}
          </Typography>{" "}
          {t("delete.sexoatatcadulieu")}
        </Typography>
      ),
      confirmationText: <Button className={classes.btn_delete}> {t("delete.dongy")}</Button>,
      cancellationText: (
        <Button className={classes.btn_add} style={{marginRight: 0}}>
          {t("delete.huybo")}
        </Button>
      ),
    })
      .then(async () => {
        const res: ResponseStatus = await managerCategoryApi.deleteCategory(category.id);
        if (res.responseCode === "00") {
          toast.success(`${t("managerCategory.xoachudethanhcong")}`);
          dispatch(fetchCategoryList());
        } else {
          if (res.responseCode === "30") {
            toast.error(`${t("managerCategory.xoachudethatbai")}`);
            throw new Error("Delete category is failed");
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleEditCategory = (value: Category) => {
    setOpenModal(true);
    setValueCategory(value);
  };
  return (
    <div ref={containerRef}>
      <Fragment>
        <Box>
          {categoryList.length > 0 ? (
            <>
              <TableContainer component={Paper} className={classes.container}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center" width="130px">
                    {t("stt")}
                  </StyledTableCell>
                  {/* <StyledTableCell align="center">{t("managerCategory.bophan")}</StyledTableCell> */}
                  <StyledTableCell align="center">{t("managerCategory.chude")}</StyledTableCell>
                  <StyledTableCell align="center" width="400px">
                    {t("thaotac")}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {categoryList.map((category, index) => (
                  <TableRow key={category.id} hover>
                    <StyledTableCell align="center" component="th" scope="row">
                      <Typography style={{ fontWeight: 700, color: "#334155", fontSize: "0.875rem" }}>
                        {index + 1}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Typography style={{ fontWeight: 700, color: "#0F172A", fontSize: "0.875rem" }}>
                        {category.name}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Button
                        className={classes.btn_add}
                        onClick={() => handleEditCategory(category)}
                      >
                        {t("button.edit")}
                      </Button>
                      <Button
                        className={classes.btn_delete}
                        onClick={() => handleDeleteCategory(category)}
                      >
                        {t("button.delete")}
                      </Button>
                    </StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Mobile View: ListView */}
          {isMobile && (
            <Box className={classes.mobileListView}>
              {categoryList.map((category, index) => (
                <Box key={category.id} className={classes.mobileCard}>
                  {/* Card Header: Title & Index */}
                  <Box className={classes.mobileCardHeader}>
                    <Box>
                      <Typography variant="subtitle2" style={{ fontWeight: 800, color: "#0F172A" }}>
                        {category.name}
                      </Typography>
                      <Typography variant="caption" style={{ color: "#64748B" }}>
                        STT: {index + 1}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Card Body: Info rows */}
                  <Box className={classes.mobileCardBody}>
                    <Box className={classes.mobileCardRow}>
                      <Typography variant="caption" style={{ color: "#64748B", fontWeight: 700 }}>
                        TÊN CHỦ ĐỀ
                      </Typography>
                      <Typography variant="caption" style={{ fontWeight: 600, color: "#334155" }}>
                        {category.name}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Card Actions */}
                  <Box className={classes.mobileCardActions}>
                    <Button
                      className={classes.btn_delete}
                      style={{ margin: 0 }}
                      onClick={() => handleDeleteCategory(category)}
                    >
                      Xóa
                    </Button>
                    <Button
                      className={classes.btn_add}
                      style={{ margin: 0 }}
                      onClick={() => handleEditCategory(category)}
                    >
                      Sửa
                    </Button>
                  </Box>
                </Box>
              ))}
            </Box>
          )}
          </>
        ) : (
          <EmptyComponent />
        )}
        <Box mt={3} display="flex" justifyContent="flex-end"></Box>
      </Box>

      <EditCategory
        valueCategory={valueCategory}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      </Fragment>
    </div>
  );
}
